import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { AppSettings } from '../models/app-settings';
import { TranslateService } from "@ngx-translate/core";
import { ErrorResponseHandler } from "./error-handler.service";

@Injectable({ providedIn: 'root' })
export class AppService {
  appSettings = new AppSettings();
  error = null

  private http = inject(HttpClient);
  private translateService = inject(TranslateService);

  initAppSettings(): Observable<AppSettings> {
    return this.http.get<AppSettings>('/api/public/v1/settings').pipe(
      tap({
        next: (settings) => {
          this.appSettings = settings
          this.error = null
        },
        error: (err) => {
          this.appSettings = new AppSettings()
          this.error = ErrorResponseHandler.getFormattedMessage(
            this.translateService.instant('general.error.app-settings-error'),
            err?.error?.traceId ?? err?.error?.id
          );
        }
      })
    );
  }
}
